import { render, staticRenderFns } from "./OverlayBottomCenterIcon.vue?vue&type=template&id=a304c158&"
import script from "./OverlayBottomCenterIcon.vue?vue&type=script&lang=js&"
export * from "./OverlayBottomCenterIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports